import {
  useHasConditionValueError,
  useHasConditionValuesError,
  useHasConditionComparatorError,
  useHasConditionFieldError,
  useHasConditionFieldTypeError,
  useHasConditionValueWarning,
  useHasConditionComparatorWarning,
  useHasConditionFieldWarning,
  useHasConditionFieldTypeWarning,
  useHasConditionValuesWarning,
} from '../../../hooks/condition';

/**
 * Hook to store all condition error state and warning state
 */
export const useConditionErrorState = () => {
  const hasValueError = useHasConditionValueError();
  const hasValuesError = useHasConditionValuesError();
  const hasComparatorError = useHasConditionComparatorError();
  const hasFieldError = useHasConditionFieldError();
  const hasFieldTypeError = useHasConditionFieldTypeError();

  const hasValueWarning = useHasConditionValueWarning();
  const hasValuesWarning = useHasConditionValuesWarning();
  const hasComparatorWarning = useHasConditionComparatorWarning();
  const hasFieldWarning = useHasConditionFieldWarning();
  const hasFieldTypeWarning = useHasConditionFieldTypeWarning();

  return {
    hasValueError,
    hasValuesError,
    hasComparatorError,
    hasFieldError,
    hasFieldTypeError,
    hasValueWarning,
    hasValuesWarning,
    hasComparatorWarning,
    hasFieldWarning,
    hasFieldTypeWarning,
  };
};
